import { Decoration, DecorationSet } from '@milkdown/kit/prose/view';
import { Plugin, PluginKey } from '@milkdown/kit/prose/state';
import { $prose } from '@milkdown/kit/utils';

// Plugin key for grammar check loading decoration
export const grammarCheckDecoKey = new PluginKey('grammarCheckDeco');

/**
 * Milkdown plugin that shows a pulsing highlight decoration during grammar check.
 * Install this plugin on the editor to enable the loading animation.
 */
export const grammarCheckDecorationPlugin = $prose(() => {
  return new Plugin({
    key: grammarCheckDecoKey,
    state: {
      init: () => DecorationSet.empty,
      apply: (tr, decoSet) => {
        const meta = tr.getMeta(grammarCheckDecoKey);
        if (meta?.clear) {
          return DecorationSet.empty;
        }
        if (meta?.from !== undefined && meta?.to !== undefined) {
          const deco = Decoration.inline(meta.from, meta.to, {
            class: 'grammar-check-highlight',
          });

          return DecorationSet.create(tr.doc, [deco]);
        }

        // Map existing decorations through document changes
        return decoSet.map(tr.mapping, tr.doc);
      },
    },
    props: {
      decorations: (state) => grammarCheckDecoKey.getState(state),
    },
  });
});
